/* eslint-disable */
<template>
							<div @click="clickProject(id)">
									<p v-b-toggle="`accordion-${id}`" variant="info" class="project-title"  :ref="`title-${id}`"><span class="red-text mr-4 project-no">{{id}}.</span>{{title.toUpperCase()}}</p>
									<b-collapse
										:id="`accordion-${id}`"
										visible
										accordion="my-accordion"
										role="tabpanel"
									>
										<b-card-body class="pl-0 pt-0">
										<b-card-text class="p">{{ text }}</b-card-text>
										<a :href="link" target="_blank" class="link-arrow d-flex">
											<p class="red-text mb-0">View</p>
											<svg xmlns="http://www.w3.org/2000/svg" width="18" height="25.197" viewBox="0 0 25.342 25.197"><g transform="translate(0 1.5)"><path d="M911.487,278.077h23.842v22.588" transform="translate(-911.487 -278.077)" fill="none" stroke="#8d140e" id="g1" stroke-width="3"/><path d="M936.329,277.077l-22.637,22.637" transform="translate(-912.487 -277.077)" fill="none" stroke="#8d140e" id="g2" stroke-width="3"/></g></svg>
										</a>
										</b-card-body>
									</b-collapse>
						</div>
</template>

<script>
export default {
	props:[
		"id", "title", "text","imgSrc","link"
	],
	methods:{
		clickProject(title){
			let projects = document.querySelectorAll('.project-title');
			for(let i = 0; i<projects.length; i++){
				projects[i].classList.remove("slide-animate", "red-text" , "pl-5");
			}
			let myref = this.$refs[`title-${title}`];
				myref.classList.add("slide-animate" , "red-text" , "pl-5");
				this.$store.commit("changeImgSrc", this.imgSrc);
		}
	}
}
</script>

<style scoped>
.project-title{
	font-size:25px;
	font-weight: bold;
	cursor:pointer;
}
.project-no{
	font-size:20px;
	font-weight: 300;
}
.slide-animate{
	transition: all .5s ease-in;
}
.link-arrow p{
	opacity:0;
	width:0px;
	transition: all .2s ease-in;
}
.link-arrow:hover p{
	opacity: 1;
	width:auto;
	/* margin-right:3px; */
	transition: all .5s ease-in-out;
}
.link-arrow:hover svg{
	margin-left: 20px;
	transition: all 0.3s ease-in-out
}
.link-arrow svg{
		transition: all .2s ease-in;
}
@media only screen and (max-width:767px) {
.project-title{
	font-size:20px;
	font-weight: bold;
}
	
}
@media only screen and (min-width: 768px) and (max-width: 999px){
	.project-title{
	font-size:20px;
	font-weight: bold;
}
}
</style>